export default class CallAnnotationService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;

    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  annotateCall(accountId, callId, tag) {
    if (!tag.type) {
      tag.type = 'Annotations';
    }

    const data = {
      inboundCallId: callId,
      tags: [{
        tagName: tag.name,
        tagType: tag.type,
        tagValue: tag.value
      }]
    };

    const url = this.serviceBaseUri + accountId + '/calls/annotate';

    return this.$http.post(url, data);
  }
}
